module.exports = __webpack_public_path__ + "img/article3.44d8b488.jpg";